<div class="container trend-container">
    <h1 class="principal-title">Tendencias</h1>
    <div class="principal-summary">Una tendencia es un fenómeno que muestra un comportamiento determinado, el
        cual se puede asumir que continuará en el futuro. Es decir, una tendencia se define como el posible
        comportamiento a futuro de una variable asumiendo la continuidad de su patrón.
    </div>
    <app-carousel [idEventTypeForSlider]="idEvenType"></app-carousel>
    <div class="container-button">
        <div class="row">
            <div class="col-md-6 mb-3 mb-md-0">
                <a class="btn-foi" *ngIf="t1 && t1.urllistado" href="{{URL}}{{t1.urllistado}}" target="_blank">
                    <i class="fa fa-file-pdf-o icon-pdf"></i>Listado de tendencias
                </a>
            </div>            
            <div class="col-md-6">
                <app-search-contextual [idEvenType]="idEvenType"></app-search-contextual>
            </div>
        </div>
    </div>

    <div class="normal-text"> A continuación, seleccione alguna tendencia según unidad territorial o
        sector para obtener mayor información.
    </div>
    <br>

    <div class="row mb-5 text-center">
        <a class="col-6 col-sm-6 col-md-3 link-trends" routerLink="../tendencia-global">
            <img class="img-trends tg" src="assets/img/t/tg-w.webp" alt="">
            <br>Tendencias globales</a>
        <a class="col-6 col-sm-6 col-md-3 link-trends" routerLink="../tendencia-nacional">
            <img class="img-trends tn" src="assets/img/t/tn-w.webp" alt="">
            <br>Tendencias nacionales</a>
        <a class="col-6 col-sm-6 col-md-3 link-trends" routerLink="../tendencia-territorial">
            <img class="img-trends tt" src="assets/img/t/tt-w.webp" alt="">
            <br>Tendencias territoriales</a>
        <a class="col-6 col-sm-6 col-md-3 link-trends" routerLink="../tendencia-sectorial">
            <img class="img-trends ts" src="assets/img/t/ts-w.webp" alt="">
            <br>Tendencias sectoriales</a>
    </div>
    <div class="text-Blue">
        * Revisar documento metodológico sobre tendencias
        <a *ngIf="t1 && t1.urlmetodologico" href="{{URL}}{{t1.urlmetodologico}}" target="_blank">aquí</a>
    </div>
</div>